import IClientConfig from '../models/IClientConfig';
import { apiFetch } from './http';

// Hard-coded safe fallbacks used if the BFF /api/v1/config fetch fails.
// These mirror the production defaults in auth/config and appapi/config.
// The server still enforces the real values regardless of what the SPA shows.
export const DEFAULT_CLIENT_CONFIG: IClientConfig = {
    minBetProximityMeters: 500,
    minBetRefreshIntervalSeconds: 300,
    passwordMinLength: 10,
    passwordMaxLength: 128,
    passwordRequireUpper: true,
    passwordRequireLower: true,
    passwordRequireDigit: true,
    passwordRequireSpecial: true,
};

export async function fetchClientConfig(): Promise<IClientConfig> {
    try {
        const res = await apiFetch('/api/v1/config');
        if (!res.ok) return DEFAULT_CLIENT_CONFIG;
        const data = await res.json();
        return {
            minBetProximityMeters: numberOrDefault(data.minBetProximityMeters, DEFAULT_CLIENT_CONFIG.minBetProximityMeters),
            minBetRefreshIntervalSeconds: Math.max(30, numberOrDefault(data.minBetRefreshIntervalSeconds, DEFAULT_CLIENT_CONFIG.minBetRefreshIntervalSeconds)),
            passwordMinLength: numberOrDefault(data.passwordMinLength, DEFAULT_CLIENT_CONFIG.passwordMinLength),
            passwordMaxLength: numberOrDefault(data.passwordMaxLength, DEFAULT_CLIENT_CONFIG.passwordMaxLength),
            passwordRequireUpper: boolOrDefault(data.passwordRequireUpper, DEFAULT_CLIENT_CONFIG.passwordRequireUpper),
            passwordRequireLower: boolOrDefault(data.passwordRequireLower, DEFAULT_CLIENT_CONFIG.passwordRequireLower),
            passwordRequireDigit: boolOrDefault(data.passwordRequireDigit, DEFAULT_CLIENT_CONFIG.passwordRequireDigit),
            passwordRequireSpecial: boolOrDefault(data.passwordRequireSpecial, DEFAULT_CLIENT_CONFIG.passwordRequireSpecial),
        };
    } catch {
        return DEFAULT_CLIENT_CONFIG;
    }
}

function numberOrDefault(v: unknown, d: number): number {
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : d;
}

function boolOrDefault(v: unknown, d: boolean): boolean {
    return typeof v === 'boolean' ? v : d;
}
